// ===== 移动端 Footer 折叠 =====
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth <= 749) {
    document.querySelectorAll('.footer-block__heading[data-accordion]').forEach(heading => {
      heading.addEventListener('click', () => {
        heading.classList.toggle('active');
        const content = heading.nextElementSibling;
        if (content) {
          content.style.display = content.style.display === 'block' ? 'none' : 'block';
        }
      });
    });
  }
});
